import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faConciergeBell,
  faBuilding,
  faIndustry,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

const servicesData = [
  {
    icon: faIndustry,
    name: "Food Production",
    text: "Using advanced technology and strict quality controls, we produce high-quality food products. Our flexible private label manufacturing offers customized solutions for retailers and partners, ensuring consistent excellence.",
  },
  {
    icon: faBuilding,
    name: "Infrastructure & Real Estate",
    text: "We design and deliver modern, sustainable infrastructure and real estate developments that foster community growth and provide enduring value for investors.",
  },
  {
    icon: faGlobe,
    name: "Global Trade",
    text: "We import high-quality agricultural products from trusted international partners and export our premium goods worldwide, ensuring seamless supply chains that meet the demands of diverse markets.",
  },
  {
    icon: faConciergeBell,
    name: "Hospitality",
    text: "Our hospitality ventures deliver authentic culinary experiences through a network of restaurants that reflect cultural richness and premium service.",
  }
];

export const Services = () => {
  return (
    <section
      id="services"
      style={{
        padding: "60px 20px",
        background: "linear-gradient(to right, rgb(63, 78, 79), rgb(63, 78, 79))",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
        <h2
          style={{
            fontSize: "2.8rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#DCD7C9",
          }}
        >
          Our Divisions
        </h2>
        <p
          style={{
            color: "#DCD7C9",
            maxWidth: 600,
            margin: "0 auto 40px",
            fontSize: "1.4rem",
          }}
        >
          At Tahil Group, we build value across industries — food, real estate, global trade and hospitality — through innovation and excellence.
        </p>

        {/* SERVICES GRID */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "70%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "24px",
            }}
          >
            {servicesData.map(({ icon, name, text }, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#DCD7C9",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 12px 20px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
                }}
              >
                {/* ICON SIDE */}
                <div
                  style={{
                    background: "linear-gradient(to right,rgb(202, 150, 78), #C38745)",
                    width: 80,
                    minWidth: 80,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "32px",
                  }}
                >
                  <FontAwesomeIcon icon={icon} />
                </div>

                {/* TEXT SIDE */}
                <div style={{ padding: "16px 18px", textAlign: "left", flex: 1 }}>
                  <h3
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      margin: "0 0 8px",
                      color: "#3F4E4F",
                    }}
                  >
                    {name}
                  </h3>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "1rem",
                      lineHeight: 1.5,
                      color: "#3F4E4F",
                    }}
                  >
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
